import { DataPagination } from 'projects/access-control/src/app/Domain/Adapters';
import { Client } from 'projects/access-control/src/app/Domain/Entities/client.interface';
import { AllGroupsI, Groups } from 'projects/access-control/src/app/Domain/Entities/group.interface';
import { Pagination } from 'projects/access-control/src/app/Domain/Entities/pagination.interface';
import { UsersGroups } from 'projects/access-control/src/app/Domain/Entities/userGroups.interface';
export const GROUPS_STATE_NAME = 'group';

export interface GroupState {
	groups: Groups[] | AllGroupsI[];
	groupSelected: Groups;
	pagination: DataPagination;
	error: any;
	loading: boolean;
	loadingGeneral: boolean;
	viewGroups: boolean;
}

export const initialStateModule: GroupState = {
	groups: [],
	groupSelected: {} as Groups,
	pagination: {} as DataPagination,
	error: null,
	loading: false,
	loadingGeneral: false,
	viewGroups: true,
};
